import React, { useEffect } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { getlocal, getSpecificlocal } from "../../functions/localstorage";
import Login from "../../pages/Login";
import { URLPRIFIX } from "../../functions/api";
import Dashboard from "../../pages/Dashboard";
import { useStore } from "../StateProvider";
import UserList from "../../pages/users/UserList";
import UserForm from "../../pages/users/UserForm";
import CustomerForm1 from "../../pages/Customer/CustomerForm";
import CustomerList1 from "../../pages/Customer/CustomerList";
import ContactsList from "../../pages/Contacts/ContactsList";
import ContactForm from "../../pages/Contacts/ContactForm";
import NonLitigation from "../../pages/NonLitigation";
import FormsList from "../../pages/ClientForms/FormsList";
import FormsForm from "../../pages/ClientForms/FormsForm";
import CategoryList from "../../pages/Category/CategoryList";
import CategoryForm from "../../pages/Category/CategoryForm";
import FilmForm from "../../pages/Film/FilmForm";
import LProjectList from "../../pages/Litigation/Project//ProjectList";
import ProjectList from "../../pages/Project/ProjectList";
import ProjectForm from "../../pages/Project/ProjectForm";
import DocumentsList from "../../pages/Documents/DocumentsList";
import DocumentsForm from "../../pages/Documents/DocumentsForm";
import TasksList from "../../pages/Tasks/TasksList";
import TasksForm from "../../pages/Tasks/TasksForm";
import Editor from "../../pages/Editor";
import FilmFormCreate from "../../pages/ClientForms/FilmFormCreate";
import Layout from "./Layout";
import UnAuthorized401 from "../../pages/UnAuthorized401";
import FilmList from "../../pages/Film/FilmList";
import CompanyList from "../../pages/Companies/CompanyList";
import CompanyForm from "../../pages/Companies/CompanyForm";
import CompanyCardList from "../../pages/Companies/CompanyCardList";
import JournalsForm from "../../pages/Accounts/Journals/journalsForm";
import JournalsList from "../../pages/Accounts/Journals/JournalListUpdated";
import GroupList from "../../pages/Accounts/Group/GroupList";
import LedgerList from "../../pages/Accounts/Ledger/LedgerList";
import GroupForm from "../../pages/Accounts/Group/GroupForm";
import LedgerForm from "../../pages/Accounts/Ledger/LedgerForm";
import AccountsDashboard from "../../pages/Accounts/AccountsDashboard";
import SalesForm from "../../pages/Accounts/Sales/SalesForm";
import SalesList from "../../pages/Accounts/Sales/SalesList";
import InvoiceForm from "../../pages/Accounts/Invoice/InvoiceForm";
import InvoiceList from "../../pages/Accounts/Invoice/InvoiceList";
import ReceiptForm from "../../pages/Accounts/Receipt/ReceiptForm";
import ReceiptList from "../../pages/Accounts/Receipt/ReceiptList";
import BalanceSheet from "../../pages/Accounts/Report/BalanceSheet";
import TrailBalance from "../../pages/Accounts/Report/TrailBalance";
import Reconciliation from "../../pages/Accounts/Report/Reconciliation";
import AdvancedReconciliation from "../../pages/Accounts/Report/AdvancedReconciliation";
import StatementofAccounts from "../../pages/Accounts/Report/StatementofAccounts";
import ExpenseForm from "../../pages/Accounts/Expense/ExpenseForm";
import ExpenseList from "../../pages/Accounts/Expense/ExpenseList";
import ProfitLoss from "../../pages/Accounts/Report/ProfitLoss";
import CustomerForm from "../../pages/Accounts/Customer/CustomerForm";
import CustomerList from "../../pages/Accounts/Customer/CustomerList";
import PayablesForm from "../../pages/Accounts/Payables/PayablesForm";
import PayablesList from "../../pages/Accounts/Payables/PayablesList";
import TDSReport from "../../pages/Accounts/Report/TDSReport";
import AccountsLayout from "../../pages/Accounts/AccountsLayout";
import DayBook from "../../pages/Accounts/Report/DayBook";
import CustomerLedger from "../../pages/Accounts/Report/CustomerLedger";
import LProjectForm from "../../pages/Litigation/Project/ProjectForm";
import TProjectList from "../../pages/TradeMark/Project/ProjectList";
import TProjectForm from "../../pages/TradeMark/Project/ProjectForm";
import TTaskList from "../../pages/TradeMark/Task/TasksList";
import VendorForm from "../../pages/Accounts/Vendor/VendorForm";
import VendorList from "../../pages/Accounts/Vendor/VendorList";
import BudgetList from "../../pages/Accounts/Budget/BudgetList";
import BudgetForm from "../../pages/Accounts/Budget/BudgetForm";
import BudgetActual from "../../pages/Accounts/Report/BudgetActual";
import CompanyDashboard from "../../pages/Companies/CompanyDashboard";
import InvoiceSerial from "../../pages/Accounts/Configurations/InvoiceSerial";
import BillingReport from "../../pages/Accounts/Report/BillingReport";
import Task_Assigned from "../../pages/Tasks/Task_Assigned";
import TTask_Assigned from "../../pages/TradeMark/Task/Task_Assigned";
import LTask_Assigned from "../../pages/Litigation/Task/Task_Assigned";
import TTaskForm from "../../pages/TradeMark/Task/TasksForm";
import LTaskList from "../../pages/Litigation/Task/TasksList";
import LTaskForm from "../../pages/Litigation/Task/TasksForm";
import Maintanence from "../../pages/Maintanence";
import DashboardNew from "../../pages/Dashboard/DashboardNew";
import CalendarPage from "../Elements/Calendar";
import BadgeTaskList from "../../pages/Badges/BadgeTaskList";
import ProjectListUpdated from "../../pages/Project/ProjectListUpdated";
import DocumentsListUpdate from "../../pages/Documents/DocumentsListUpdate";
import TasksListUp from "../../pages/Tasks/TaskListUp";
import InvoiceListUpdated from "../../pages/Accounts/Invoice/InvoiceListUpdated";
import LProjectListUpd from "../../pages/Litigation/Project/ProjectListUpd";
import LTaskListUpd from "../../pages/Litigation/Task/TaskListUpd";
import LTask_AssignedUpd from "../../pages/Litigation/Task/Task_AssignedUpd";
import TProjectListUpdated from "../../pages/TradeMark/Project/ProjectListUpdated";
import TTasksListUpd from "../../pages/TradeMark/Task/TaskListUpd";
import TTask_AssignedUpd from "../../pages/TradeMark/Task/Task_AssignedUpd";
import FormListUpd from "../../pages/ClientForms/FormsListUpd";
import ReceiptListUpdated from "../../pages/Accounts/Receipt/ReceiptListUpdated";
import ExpenseListUpdated from "../../pages/Accounts/Expense/ExpenseListUpdated";
import PayableListUpdated from "../../pages/Accounts/Payables/PayableListUpdated";
import GroupListUpd from "../../pages/Accounts/Group/GroupListUpd";
import LedgerListUpd from "../../pages/Accounts/Ledger/LedgerListUpd";
import CustomerListUpd from "../../pages/Accounts/Customer/CustomerListUpd";
import VendorListUpd from "../../pages/Accounts/Vendor/VendorListUpd";
import UserListUpd from "../../pages/users/UserListUpdated";
import CustomerListUpdated from "../../pages/Customer/CustomerListUpdated";
import CategoryListUpd from "../../pages/Category/CatergoryListUpdated";
import FilmListUpd from "../../pages/Film/FilmListUpdated";
import ContactListUpd from "../../pages/Contacts/ContactListUpdated";
import OverdueTasks from "../../pages/Tasks/OverdueTasks";
import TemplateMaster from "../../pages/TemplateMaster/TemplateMaster";
import TOverdueTasks from "../../pages/TradeMark/Task/Over_due_task";


const PageRouter = () => {
  const store = useStore();
  let props = getlocal("properties") || {};
  const user = getlocal("system")?.user || {};

  if (user?.role == 1) {
    props = new Proxy({}, {
      get: () => new Proxy({}, {
        get: () => true
      })
    });
  }

  let url = window.location.pathname;
  useEffect(() => {
    let login = getlocal("system").login;
    if (!url.includes("/" + URLPRIFIX + "/forms")) {
      if (!login) {
        store.navTo("/login");
      } else {
        if (url === "/login" || url === "/") {
          store.navTo("/" + URLPRIFIX + "/view/dashboard");
        }
      }
    }

    // to provide the break on the application comment or uncomment the below line
    // if (getSpecificlocal("breakdown") != "true") store.navTo("/Breakdown");
  }, []);
  return (
    <Routes>
      {/* login */}
      <Route path="/" element={<Navigate to={"/login"} />} />
      <Route path="/Breakdown" element={<Maintanence />} />
      <Route path="/login" element={<Login />} />

      <Route
        path={"/demo/dashboard"}
        element={
          <Layout>
            {props?.dashboard?.view ? <Dashboard /> : <UnAuthorized401 />}
          </Layout>
        }
      />
      <Route
        path={"/demo/view/dashboard"}
        element={
          <Layout>
            {props?.dashboard?.view ? <DashboardNew /> : <UnAuthorized401 />}
          </Layout>
        }
      />
      <Route
        path={"/demo/tasks/badgeTask/:id"}
        element={
          <Layout>
            {props?.dashboard?.view ? (
              <BadgeTaskList />
            ) : (
              <UnAuthorized401 />
            )}
          </Layout>
        }
      />
      <Route
        path={"/demo/calendarpage"}
        element={
          <Layout>
            {props?.dashboard?.view ? <CalendarPage /> : <UnAuthorized401 />}
          </Layout>
        }
      />

      <Route
        path={"/demo/users/list"}
        element={
          <Layout>
            {props?.users?.view ?
              // <UserList />
              <UserListUpd />
              : <UnAuthorized401 />}
          </Layout>
        }
      />
      <Route
        path={"/demo/users/create"}
        element={
          <Layout>
            {props?.users?.add ? <UserForm /> : <UnAuthorized401 />}
          </Layout>
        }
      />
      <Route
        path={"/demo/users/:option/:id"}
        element={
          <Layout>
            {props?.users?.view ? <UserForm /> : <UnAuthorized401 />}
          </Layout>
        }
      />

      <Route
        path={"/demo/customer/create"}
        element={
          <Layout>
            {props?.customers?.add ? <CustomerForm1 /> : <UnAuthorized401 />}
          </Layout>
        }
      />
      <Route
        path={"/demo/customer/list"}
        element={
          <Layout>
            {props?.customers?.view ?
              // <CustomerList1 /> 
              <CustomerListUpdated />
              : <UnAuthorized401 />}
          </Layout>
        }
      />
      <Route
        path={"/demo/customer/:option/:id"}
        element={
          <Layout>
            {props?.customers?.view ? <CustomerForm1 /> : <UnAuthorized401 />}
          </Layout>
        }
      />

      <Route
        path={"/demo/categories/list"}
        element={
          <Layout>
            {props?.categories?.view ?
              // <CategoryList /> 
              <CategoryListUpd />
              : <UnAuthorized401 />}
          </Layout>
        }
      />
      <Route
        path={"/demo/categories/create"}
        element={
          <Layout>
            {props?.categories?.add ? <CategoryForm /> : <UnAuthorized401 />}
          </Layout>
        }
      />
      <Route
        path={"/demo/categories/:option/:id"}
        element={
          <Layout>
            {props?.categories?.view ? <CategoryForm /> : <UnAuthorized401 />}
          </Layout>
        }
      />

      <Route
        path={"/demo/filmmaster/create"}
        element={
          <Layout>
            {props?.films?.add ? <FilmForm /> : <UnAuthorized401 />}
          </Layout>
        }
      />
      <Route
        path={"demo/filmmaster/list"}
        element={
          <Layout>
            {props?.films?.view ?
              // <FilmList /> 
              <FilmListUpd />
              : <UnAuthorized401 />}
          </Layout>
        }
      />
      <Route
        path={"/demo/filmmaster/:option/:id"}
        element={
          <Layout>
            {props?.films?.view ? <FilmForm /> : <UnAuthorized401 />}
          </Layout>
        }
      />

      <Route
        path={"/demo/contacts/list"}
        element={
          <Layout>
            {props?.contacts?.view ?
              // <ContactsList />
              <ContactListUpd />
              : <UnAuthorized401 />}
          </Layout>
        }
      />
      <Route
        path={"/demo/contacts/create"}
        element={
          <Layout>
            {props?.contacts?.add ? <ContactForm /> : <UnAuthorized401 />}
          </Layout>
        }
      />
      <Route
        path={"/demo/contacts/:option/:id"}
        element={
          <Layout>
            {props?.contacts?.view ? <ContactForm /> : <UnAuthorized401 />}
          </Layout>
        }
      />

      <Route
        path={"/demo/projects/list"}
        element={
          <Layout>
            {props?.nonlitigation_projects?.view ? (
              <ProjectListUpdated />
            ) : (
              <UnAuthorized401 />
            )}
          </Layout>
        }
      />
      <Route
        path={"/demo/projects/create"}
        element={
          <Layout>
            {props?.nonlitigation_projects?.add ? (
              <ProjectForm />
            ) : (
              <UnAuthorized401 />
            )}
          </Layout>
        }
      />
      <Route
        path={"/demo/projects/:option/:id"}
        element={
          <Layout>
            {props?.nonlitigation_projects?.view ? (
              <ProjectForm />
            ) : (
              <UnAuthorized401 />
            )}
          </Layout>
        }
      />

      <Route
        path={"/demo/documents/list"}
        element={
          <Layout>
            {props?.nonlitigation_documents?.view ? (
              <DocumentsListUpdate />
            ) : (
              <UnAuthorized401 />
            )}
          </Layout>
        }
      />
      <Route
        path={"/demo/documents/create"}
        element={
          <Layout>
            {props?.nonlitigation_documents?.add ? (
              <DocumentsForm />
            ) : (
              <UnAuthorized401 />
            )}
          </Layout>
        }
      />
      <Route
        path={"/demo/documents/:option/:id"}
        element={
          <Layout>
            {props?.nonlitigation_documents?.view ? (
              <DocumentsForm />
            ) : (
              <UnAuthorized401 />
            )}
          </Layout>
        }
      />

      <Route
        path={"/demo/tasks/list"}
        element={
          <Layout>
            {props?.nonlitigation_tasks?.view ? (
              <TasksListUp />
            ) : (
              <UnAuthorized401 />
            )}
          </Layout>
        }
      />
      <Route
        path={"/demo/tasks/list/:id"}
        element={
          <Layout>
            {props?.nonlitigation_tasks?.view ? (
              <Task_Assigned />
            ) : (
              <UnAuthorized401 />
            )}
          </Layout>
        }
      />
      <Route
        path={"/demo/tasks/create"}
        element={
          <Layout>
            {props?.nonlitigation_tasks?.add ? (
              <TasksForm />
            ) : (
              <UnAuthorized401 />
            )}
          </Layout>
        }
      />
      <Route
        path={"/demo/tasks/create?:dueDate"}
        element={
          <Layout>
            {props?.nonlitigation_tasks?.add ? (
              <TasksForm />
            ) : (
              <UnAuthorized401 />
            )}
          </Layout>
        }
      />
      <Route
        path={"/demo/tasks/:option/:id"}
        element={
          <Layout>
            {props?.nonlitigation_tasks?.view ? (
              <TasksForm />
            ) : (
              <UnAuthorized401 />
            )}
          </Layout>
        }
      />

      <Route
        path={"/demo/nonlitigation/:category"}
        element={
          <Layout>
            {props?.nonlitigation_category?.view ? (
              <NonLitigation />
            ) : (
              <UnAuthorized401 />
            )}
          </Layout>
        }
      />

      <Route
        path={"/demo/forms/list"}
        element={
          <Layout>
            {props?.forms?.view ?
              // <FormsList /> 
              <FormListUpd />
              : <UnAuthorized401 />}
          </Layout>
        }
      />
      <Route
        path={"/demo/forms/:option/:id"}
        element={
          <Layout>
            {props?.forms?.view ? <FormsForm /> : <UnAuthorized401 />}
          </Layout>
        }
      />
      <Route
        path={"/demo/forms/:clientId/:categoryid/:filmid/:filmname/:formid"}
        element={<FilmFormCreate />}
      />
      <Route
        path={"/demo/non-litigation/overdue-tasks"}
        element={
          <Layout>
            <OverdueTasks />
          </Layout>
        }
      />

      {/* \\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\ */}

      <Route
        path={"/demo/litigation/projects/list"}
        element={
          <Layout>
            {props?.litigation_projects?.view ? (
              // <LProjectList />
              <LProjectListUpd />
            ) : (
              <UnAuthorized401 />
            )}
          </Layout>
        }
      />
      {/* <Route
        path={"/demo/litigation/projectsupd/Updlist"}
        element={
          <Layout>
            {props?.litigation_projectsupd?.view ? (
              <LProjectListUpd />
            ) : (
              <UnAuthorized401 />
            )}
          </Layout>
        }
      /> */}
      <Route
        path={"/demo/litigation/projects/:option/:id"}
        element={
          <Layout>
            {props?.litigation_projects?.view ? (
              <LProjectForm />
            ) : (
              <UnAuthorized401 />
            )}
          </Layout>
        }
      />
      <Route
        path={"/demo/litigation/projects/create"}
        element={
          <Layout>
            {props?.litigation_projects?.add ? (
              <LProjectForm />
            ) : (
              <UnAuthorized401 />
            )}
          </Layout>
        }
      />
      <Route
        path={"/demo/litigation/tasks/create/:dueDate"}
        element={
          <Layout>
            {props?.litigation_projects?.add ? (
              <LProjectForm />
            ) : (
              <UnAuthorized401 />
            )}
          </Layout>
        }
      />


      <Route
        path={"/demo/litigation/tasks/list"}
        element={
          <Layout>
            {props?.litigation_tasks?.view ? (
              // <LTaskList />
              <LTaskListUpd />
            ) : (
              <UnAuthorized401 />
            )}
          </Layout>
        }
      />
      <Route
        path={"/demo/litigation/tasks/list/:id"}
        element={
          <Layout>
            {props?.litigation_tasks?.view ? (
              // <LTask_Assigned />
              <LTask_AssignedUpd />
            ) : (
              <UnAuthorized401 />
            )}
          </Layout>
        }
      />
      <Route
        path={"/demo/litigation/tasks/:option/:id"}
        element={
          <Layout>
            {props?.litigation_tasks?.view ? (
              <LTaskForm />
            ) : (
              <UnAuthorized401 />
            )}
          </Layout>
        }
      />
      <Route
        path={"/demo/litigation/tasks/create"}
        element={
          <Layout>
            {props?.litigation_tasks?.add ? <LTaskForm /> : <UnAuthorized401 />}
          </Layout>
        }
      />

      <Route
        path={"/demo/trademark/projects/list"}
        element={
          <Layout>
            {props?.trademark_projects?.view ? (
              // <TProjectList />
              <TProjectListUpdated />
            ) : (
              <UnAuthorized401 />
            )}
          </Layout>
        }
      />
      <Route
        path={"/demo/trademark/projects/:option/:id"}
        element={
          <Layout>
            {props?.trademark_projects?.view ? (
              <TProjectForm />
            ) : (
              <UnAuthorized401 />
            )}
          </Layout>
        }
      />
      <Route
        path={"/demo/trademark/projects/create"}
        element={
          <Layout>
            {props?.trademark_projects?.add ? (
              <TProjectForm />
            ) : (
              <UnAuthorized401 />
            )}
          </Layout>
        }
      />
      <Route
        path={"/demo/trademark/tasks/create/:dueDate"}
        element={
          <Layout>
            {props?.trademark_projects?.add ? (
              <TProjectForm />
            ) : (
              <UnAuthorized401 />
            )}
          </Layout>
        }
      />
      <Route
        path={"/demo/trademark/tasks/list"}
        element={
          <Layout>
            {props?.trademark_tasks?.view ?
              //  <TTaskList /> 
              <TTasksListUpd />
              : <UnAuthorized401 />}
          </Layout>
        }
      />
      <Route
        path={"/demo/trademark/tasks/list/:id"}
        element={
          <Layout>
            {props?.trademark_tasks?.view ? (
              // <TTask_Assigned />
              <TTask_AssignedUpd />
            ) : (
              <UnAuthorized401 />
            )}
          </Layout>
        }
      />
      <Route
        path={"/demo/trademark/tasks/:option/:id"}
        element={
          <Layout>
            {props?.trademark_tasks?.view ? <TTaskForm /> : <UnAuthorized401 />}
          </Layout>
        }
      />
      <Route
        path={"/demo/trademark/tasks/create"}
        element={
          <Layout>
            {props?.trademark_tasks?.add ? <TTaskForm /> : <UnAuthorized401 />}
          </Layout>
        }
      />
      <Route
        path={"/demo/trademark/tasks/overdue"}
        element={
          <Layout>
            <TOverdueTasks />
          </Layout>
        }
      />
      <Route
        path={"/demo/template-master"}
        element={
          <Layout>
            {props?.template_master?.view ? <TemplateMaster /> : <UnAuthorized401 />}
          </Layout>
        }
      />

      <Route
        path={"/demo/accounts"}
        element={
          <Layout>
            {props?.companies?.view ? <CompanyCardList /> : <UnAuthorized401 />}
          </Layout>
        }
      />
      <Route
        path={"/demo/companyaccounts/dashboard"}
        element={
          <Layout>
            {props?.companydashboard?.view ? (
              <CompanyDashboard />
            ) : (
              <UnAuthorized401 />
            )}
          </Layout>
        }
      />

      <Route
        path={"/demo/companies/create"}
        element={
          <Layout>
            {props?.companies?.add ? <CompanyForm /> : <UnAuthorized401 />}
          </Layout>
        }
      />
      <Route
        path={"/demo/companies/:option/:id"}
        element={
          <Layout>
            {props?.companies?.view ? <CompanyForm /> : <UnAuthorized401 />}
          </Layout>
        }
      />

      {/* Accounts screen routing */}
      {/* Dashboard Navigation */}
      <Route
        path={"/demo/:companyId/accounts/dashboard"}
        element={
          <AccountsLayout HeaderTitle={"Dashboard"}>
            {props?.accountsdashboard?.view ? (
              <AccountsDashboard />
            ) : (
              <UnAuthorized401 />
            )}
          </AccountsLayout>
        }
      />

      <Route
        path={"/demo/:companyId/accounts/invoice-no-generation"}
        element={
          <AccountsLayout HeaderTitle={"Transaction Sequence"}>
            {props?.configurations?.view ? (
              <InvoiceSerial />
            ) : (
              <UnAuthorized401 />
            )}
          </AccountsLayout>
        }
      />

      {/* invoice Navigation */}
      <Route
        path={"/demo/:companyId/accounts/invoice/:option"}
        element={
          <AccountsLayout HeaderTitle={"Invoice Form"}>
            {props?.invoices?.add ? <InvoiceForm /> : <UnAuthorized401 />}
          </AccountsLayout>
        }
      />
      <Route
        path={"/demo/:companyId/accounts/invoice/:option/:invoiceId"}
        element={
          <AccountsLayout HeaderTitle={"Invoice Form"}>
            {props?.invoices?.view ? <InvoiceForm /> : <UnAuthorized401 />}
          </AccountsLayout>
        }
      />
      <Route
        path={"/demo/:companyId/accounts/invoice"}
        element={
          <AccountsLayout HeaderTitle={"Invoices"}>
            {props?.invoices?.view ? <InvoiceListUpdated /> : <UnAuthorized401 />}
          </AccountsLayout>
        }
      />

      {/* receipt Navigation */}
      <Route
        path={"/demo/:companyId/accounts/receipt/:option"}
        element={
          <AccountsLayout HeaderTitle={"Receipt Form"}>
            {props?.receipts?.view ? <ReceiptForm /> : <UnAuthorized401 />}
          </AccountsLayout>
        }
      />
      <Route
        path={"/demo/:companyId/accounts/receipt/:option/:receiptId"}
        element={
          <AccountsLayout HeaderTitle={"Receipt Form"}>
            {props?.receipts?.view ? <ReceiptForm /> : <UnAuthorized401 />}
          </AccountsLayout>
        }
      />
      <Route
        path={"/demo/:companyId/accounts/receipt"}
        element={
          <AccountsLayout HeaderTitle={"Receipts"}>
            {props?.receipts?.view ?
              <ReceiptListUpdated />
              // <ReceiptList />
              : <UnAuthorized401 />}
          </AccountsLayout>
        }
      />

      {/* expense Navigation */}
      <Route
        path={"/demo/:companyId/accounts/expense/:option"}
        element={
          <AccountsLayout HeaderTitle={"Expense Form"}>
            {props?.Expenses?.add ? <ExpenseForm /> : <UnAuthorized401 />}
          </AccountsLayout>
        }
      />
      <Route
        path={"/demo/:companyId/accounts/expense/:option/:expenseId"}
        element={
          <AccountsLayout HeaderTitle={"Expense Form"}>
            {props?.Expenses?.view ? <ExpenseForm /> : <UnAuthorized401 />}
          </AccountsLayout>
        }
      />
      <Route
        path={"/demo/:companyId/accounts/expense"}
        element={
          <AccountsLayout HeaderTitle={"Expenses"}>
            {props?.Expenses?.view ?
              <ExpenseListUpdated />
              // <ExpenseList />
              : <UnAuthorized401 />}
          </AccountsLayout>
        }
      />

      {/* payable Navigation */}
      <Route
        path={"/demo/:companyId/accounts/payable/:option"}
        element={
          <AccountsLayout HeaderTitle={"Payable Form"}>
            {props?.payables?.add ? <PayablesForm /> : <UnAuthorized401 />}
          </AccountsLayout>
        }
      />
      <Route
        path={"/demo/:companyId/accounts/payable/:option/:payableId"}
        element={
          <AccountsLayout HeaderTitle={"Payable Form"}>
            {props?.payables?.view ? <PayablesForm /> : <UnAuthorized401 />}
          </AccountsLayout>
        }
      />
      <Route
        path={"/demo/:companyId/accounts/payable"}
        element={
          <AccountsLayout HeaderTitle={"Payables"}>
            {props?.payables?.view ?
              // <PayablesList /> 
              <PayableListUpdated />
              : <UnAuthorized401 />}
          </AccountsLayout>
        }
      />

      {/* Journal Navigation */}
      <Route
        path={"/demo/:companyId/accounts/journal/:option"}
        element={
          <AccountsLayout HeaderTitle={"Journal Form"}>
            {props?.journals?.add ? <JournalsForm /> : <UnAuthorized401 />}
          </AccountsLayout>
        }
      />
      <Route
        path={"/demo/:companyId/accounts/journal/:option/:journalId"}
        element={
          <AccountsLayout HeaderTitle={"Journal Form"}>
            {props?.journals?.view ? <JournalsForm /> : <UnAuthorized401 />}
          </AccountsLayout>
        }
      />
      <Route
        path={"/demo/:companyId/accounts/journal"}
        element={
          <AccountsLayout HeaderTitle={"Journals"}>
            {props?.journals?.view ? <JournalsList /> : <UnAuthorized401 />}
          </AccountsLayout>
        }
      />

      {/* sales Navigation */}
      {/* <Route
        path={"/demo/:companyId/accounts/sales/:option"}
        element={<SalesForm />}
      />
      <Route
        path={"/demo/:companyId/accounts/sales/:option/:salesId"}
        element={<SalesForm />}
      />
      <Route path={"/demo/:companyId/accounts/sales"} element={<SalesList />} /> */}

      {/* purchase Navigation */}
      {/* <Route
        path={"/demo/:companyId/accounts/purchase/:option"}
        element={<JournalsForm />}
      />
      <Route
        path={"/demo/:companyId/accounts/purchase/:option/:purchaseId"}
        element={<JournalsForm />}
      />
      <Route
        path={"/demo/:companyId/accounts/purchase"}
        element={<JournalsList />}
      /> */}

      {/* payment Navigation */}
      {/* <Route
        path={"/demo/:companyId/accounts/payment/:option"}
        element={<JournalsForm />}
      />
      <Route
        path={"/demo/:companyId/accounts/payment/:option/:paymentId"}
        element={<JournalsForm />}
      />
      <Route
        path={"/demo/:companyId/accounts/payment"}
        element={<JournalsList />}
      /> */}

      {/* Group Navigation */}
      <Route
        path={"/demo/:companyId/accounts/group/:option"}
        element={
          <AccountsLayout HeaderTitle={"Group Form"}>
            {props?.AccountGroups?.add ? <GroupForm /> : <UnAuthorized401 />}
          </AccountsLayout>
        }
      />
      <Route
        path={"/demo/:companyId/accounts/group/:option/:groupId"}
        element={
          <AccountsLayout HeaderTitle={"Group Form"}>
            {props?.AccountGroups?.view ? <GroupForm /> : <UnAuthorized401 />}
          </AccountsLayout>
        }
      />
      <Route
        path={"/demo/:companyId/accounts/group"}
        element={
          <AccountsLayout HeaderTitle={"Account Groups"}>
            {props?.AccountGroups?.view ?
              // <GroupList />
              <GroupListUpd />
              : <UnAuthorized401 />}
          </AccountsLayout>
        }
      />

      {/*budget form and list*/}
      <Route
        path={"/demo/:companyId/accounts/budget/:option"}
        element={
          <AccountsLayout HeaderTitle={"Budget Details"}>
            {props?.budget?.add ? <BudgetForm /> : <UnAuthorized401 />}
          </AccountsLayout>
        }
      />

      <Route
        path={"/demo/:companyId/accounts/budget/:option/:id"}
        element={
          <AccountsLayout HeaderTitle={"Budget Details"}>
            {props?.budget?.view ? <BudgetForm /> : <UnAuthorized401 />}
          </AccountsLayout>
        }
      />
      <Route
        path={"/demo/:companyId/accounts/budgetlist"}
        element={
          <AccountsLayout HeaderTitle={"Budget"}>
            {props?.budget?.view ? <BudgetList /> : <UnAuthorized401 />}
          </AccountsLayout>
        }
      />

      {/* Ledger Navigation */}
      <Route
        path={"/demo/:companyId/accounts/ledger/:option"}
        element={
          <AccountsLayout HeaderTitle={"Charts of Accounts"}>
            {props?.ChartsOfAccounts?.add ? (
              <LedgerForm />
            ) : (
              <UnAuthorized401 />
            )}
          </AccountsLayout>
        }
      />
      <Route
        path={"/demo/:companyId/accounts/ledger/:option/:ledgerId"}
        element={
          <AccountsLayout HeaderTitle={"Charts of Accounts"}>
            {props?.ChartsOfAccounts?.view ? (
              <LedgerForm />
            ) : (
              <UnAuthorized401 />
            )}
          </AccountsLayout>
        }
      />
      <Route
        path={"/demo/:companyId/accounts/ledger"}
        element={
          <AccountsLayout HeaderTitle={"Charts of Accounts"}>
            {props?.ChartsOfAccounts?.view ? (
              // <LedgerList />
              <LedgerListUpd />
            ) : (
              <UnAuthorized401 />
            )}
          </AccountsLayout>
        }
      />

      {/* customer Navigation */}
      <Route
        path={"/demo/:companyId/accounts/customer/:option"}
        element={
          <AccountsLayout HeaderTitle={"Customer"}>
            {props?.customer?.add ? <CustomerForm /> : <UnAuthorized401 />}
          </AccountsLayout>
        }
      />
      <Route
        path={"/demo/:companyId/accounts/customer/:option/:customerId"}
        element={
          <AccountsLayout HeaderTitle={"Customer"}>
            {props?.customer?.view ? <CustomerForm /> : <UnAuthorized401 />}
          </AccountsLayout>
        }
      />
      <Route
        path={"/demo/:companyId/accounts/customer"}
        element={
          <AccountsLayout HeaderTitle={"Customers"}>
            {props?.customer?.view ?
              // <CustomerList /> 
              <CustomerListUpd />
              : <UnAuthorized401 />}
          </AccountsLayout>
        }
      />

      {/* vendor Navigation */}
      <Route
        path={"/demo/:companyId/accounts/vendor/:option"}
        element={
          <AccountsLayout HeaderTitle={"Vendor"}>
            {props?.vendors?.add ? <VendorForm /> : <UnAuthorized401 />}
          </AccountsLayout>
        }
      />
      <Route
        path={"/demo/:companyId/accounts/vendors/:option/:id"}
        element={
          <AccountsLayout HeaderTitle={"Vendor"}>
            {props?.vendors?.view ? <VendorForm /> : <UnAuthorized401 />}
          </AccountsLayout>
        }
      />
      <Route
        path={"/demo/:companyId/accounts/vendor"}
        element={
          <AccountsLayout HeaderTitle={"Vendors"}>
            {props?.vendors?.view ?
              // <VendorList />
              <VendorListUpd />
              : <UnAuthorized401 />}
          </AccountsLayout>
        }
      />

      {/* Bank Navigation */}
      {/* <Route
        path={"/demo/:companyId/accounts/bank/:option"}
        element={<LedgerForm />}
      />
      <Route
        path={"/demo/:companyId/accounts/bank/:option/:bankId"}
        element={<LedgerForm />}
      />
      <Route path={"/demo/:companyId/accounts/bank"} element={<LedgerList />} /> */}

      {/* Reports Navigation */}
      <Route
        path={"/demo/:companyId/accounts/trailbalance"}
        element={
          <AccountsLayout HeaderTitle={"Trial Balance"}>
            {props?.trialbalance?.view ? <TrailBalance /> : <UnAuthorized401 />}
          </AccountsLayout>
        }
      />
      <Route
        path={"/demo/:companyId/accounts/budget-vs-actual"}
        element={
          <AccountsLayout HeaderTitle={"Budget vs Actual"}>
            {props?.budgetactual?.view ? <BudgetActual /> : <UnAuthorized401 />}
          </AccountsLayout>
        }
      />
      <Route
        path={"/demo/:companyId/accounts/reconciliation"}
        element={
          <AccountsLayout HeaderTitle={"Reconciliation"}>
            {props?.reconciliation?.view ? (
              <Reconciliation />
            ) : (
              <UnAuthorized401 />
            )}
          </AccountsLayout>
        }
      />
      <Route
        path={"/demo/:companyId/accounts/advancedreconciliation"}
        element={
          <AccountsLayout HeaderTitle={"Advanced Reconciliation"}>
            {props?.reconciliation?.view ? (
              <AdvancedReconciliation />
            ) : (
              <UnAuthorized401 />
            )}
          </AccountsLayout>
        }
      />
      <Route
        path={"/demo/:companyId/accounts/statements_of_accounts"}
        element={
          <AccountsLayout HeaderTitle={"Statement of Accounts"}>
            {props?.statement_of_accounts?.view ? (
              <StatementofAccounts />
            ) : (
              <UnAuthorized401 />
            )}
          </AccountsLayout>
        }
      />
      <Route
        path={"/demo/:companyId/accounts/balancesheet"}
        element={
          <AccountsLayout HeaderTitle={"Balance Sheet"}>
            {props?.balancesheet?.view ? <BalanceSheet /> : <UnAuthorized401 />}
          </AccountsLayout>
        }
      />
      <Route
        path={"/demo/:companyId/accounts/profitloss"}
        element={
          <AccountsLayout HeaderTitle={"Profit and Loss"}>
            {props?.profitandloss?.view ? <ProfitLoss /> : <UnAuthorized401 />}
          </AccountsLayout>
        }
      />
      <Route
        path={"/demo/:companyId/accounts/daybook"}
        element={
          <AccountsLayout HeaderTitle={"Day Book"}>
            {props?.daybook?.view ? <DayBook /> : <UnAuthorized401 />}
          </AccountsLayout>
        }
      />
      <Route
        path={"/demo/:companyId/accounts/customerledger"}
        element={
          <AccountsLayout HeaderTitle={"Customer Ledger"}>
            {props?.customerledger?.view ? (
              <CustomerLedger />
            ) : (
              <UnAuthorized401 />
            )}
          </AccountsLayout>
        }
      />
      <Route
        path={"/demo/:companyId/accounts/tdsreport"}
        element={
          <AccountsLayout HeaderTitle={"TDS Report"}>
            {props?.tdsReport?.view ? <TDSReport /> : <UnAuthorized401 />}
          </AccountsLayout>
        }
      />
      <Route
        path={"/demo/:companyId/accounts/billingreport"}
        element={
          <AccountsLayout HeaderTitle={"Billing Report"}>
            {props?.billingreport?.view ? (
              <BillingReport />
            ) : (
              <UnAuthorized401 />
            )}
          </AccountsLayout>
        }
      />

      {/* Editor */}
      <Route path={"/demo/editor/:id"} element={<Editor />} />
    </Routes>
  );
};

export default PageRouter;

